export default {
  app:{
  provider: 'Provider',
  searchGames: 'Pesquisar Jogos...',
  username: 'Usuário',
  },
    nav: {
      home: 'Início',
      games: 'Jogos',
      profile: 'Perfil'
    },
   auth: {
  login: 'Entrar',
  logout: 'Sair',
  register: 'Cadastrar',
  usernamePlaceholder: 'USUÁRIO',
  passwordPlaceholder: 'SENHA',
  togglePassword: 'Mostrar/Ocultar senha',
  forgotPassword: 'Esqueceu a senha',

// Seção de autenticação:
namePlaceholder: 'Nome completo',
emailPlaceholder: 'E-mail',
confirmPasswordPlaceholder: 'Confirmar senha',
acceptTerms: 'Aceito os termos e condições',
alreadyHaveAccount: 'Já tem uma conta? Faça login',
affiliateCodePlaceholder: 'Código de afiliado (opcional)',
affiliateCode: 'Código de Afiliado',
adultConfirmation: 'Confirmação de Adulto',
registrationSuccessful: '¡Registro exitoso! Ahora puedes iniciar sesión con tus credenciales.',

    errors: {
      // Códigos de erro do backend
      user_not_found: 'Usuário não encontrado',
      active_session: 'Sessão ativa detectada',
      invalid_password: 'Senha inválida',
      account_banned: 'Conta bloqueada',
      invalid_credentials: 'Credenciais inválidas',
      // Validações do frontend
      emptyUsername: 'O campo usuário não pode estar vazio',
      emptyPassword: 'O campo senha não pode estar vazio',
      // Erros gerais
      connectionError: 'Erro de conexão',
      serverError: 'Erro do servidor, tente novamente mais tarde',
      // Erro de registro:
emptyName: 'O nome completo é obrigatório',
emptyEmail: 'O e-mail é obrigatório',
passwordMismatch: 'As senhas não coincidem',
termsRequired: 'Você deve aceitar os termos e condições',
registerFailed: 'Erro ao registrar a conta. Tente novamente.',
emailInvalid: 'E-mail inválido',
emailTaken: 'O e-mail já está em uso',
usernameTaken: 'O nome de usuário já está em uso',
usernameInvalid: 'O nome de usuário deve ter pelo menos 3 caracteres',
passwordWeak: 'A senha deve ter pelo menos 8 caracteres',
passwordInvalid: 'A senha deve ter pelo menos 8 caracteres',
passwordRequired: 'A senha é obrigatória',
usernameRequired: 'O nome de usuário é obrigatório',
emailRequired: 'O e-mail é obrigatório',
loginRequired: 'Você deve fazer login para continuar',
adultConfirmationRequired: 'Você deve confirmar que tem mais de 18 anos',
    }
},
    loading: {
    title: 'Carregando',
    resources: 'Resources',
    credentials: 'Credenciais',
    games: 'Jogos',
    jackpots: 'Jackpots',
    balances: 'Saldos'
  },

   account: {
    title: 'Conta',
    balance: 'Saldo',
    credit: 'Crédito',
    bonus: 'Bônus',
    terminal: 'Terminal',
    id: 'ID',
    logout: 'Sair'
  },
  pagination: {
    loadMoreGames : "Carregar mais jogos",
    noMoreGames : "Não há mais jogos para carregar",
    show: "Mostrar",
    of : "de",
    games : "jogos",
  },
  "header": {
      "return_lobby": "Retornar ao lobby"
    },
    "cashback": {
     "notify_bonus_message": "Você recebeu um bônus de cashback de:",
    },
  footer: {
    contactUs: 'Contate-nos',
    followUs: 'Siga-nos',
    aboutUs: 'Sobre nós',
    termsAndConditions: 'Termos e condições',
    privacyPolicy: 'Política de privacidade',
    responsibleGaming: 'Jogo responsável',
    affiliates: 'Afiliados',
    faq: 'Perguntas frequentes',
    blog: 'Blog',
    mobileApp: 'Aplicativo móvel',
    promotions: 'Promoções',
    support: 'Suporte',
    paymentMethods: 'Métodos de pagamento',
    gameProviders: 'Fornecedores de jogos',
    socialMedia: 'Mídias sociais',
    allRightsReserved: 'Todos os direitos reservados',
},
report: {
  tittle: 'Meus Relatórios',
  user: 'Usuário',
  transactions: 'Transações',
  from: 'De',
  to: 'Até',
  type: 'Tipo',
  all: 'Todos',
  deposits: 'Depósitos',
  withdrawals: 'Saques',
  total_deposits: 'Total de Depósitos',
  total_withdrawals: 'Total de Saques',
  total_net: 'Saldo Líquido',
  date: 'Data',
  amount: 'Valor',
  description: 'Descrição',
  page: 'Página',
  of: 'de',
  previous: 'Anterior',
  next: 'Próximo',
  loading_transactions: 'Carregando Transações...',
  no_transactions_found_for_this_period: 'Nenhuma transação encontrada para este período',
  games: 'Jogos',
  game: 'Jogo',
  provider: 'Provedor',
  total_bet: 'Total Apostado',
  total_win: 'Total Ganho',
  net_result: 'Lucro Líquido',
  average_rtp: 'RTP',
  no_game_data_found: 'Nenhum dado de jogo encontrado',
  try_different_date_range: 'Tente um intervalo de datas diferente',
  bonuses: 'Bônus',
  status: 'Status',
  all_statuses: 'Todos',
  collected: 'Coletado',
  pending: 'Pendente',
  cancelled: 'Cancelado',
  no_bonus_data_found: 'Nenhum dado de bônus encontrado',
  parent_id:'ID do Pai',  
  player_id:'ID do Jogador',  
  balance_before:'Anterior',  
  balance_after:'final',
  bet_amount:'Apostado',  
  won_loss:'Resultado',  
  bonus_type:'Bônus',  
  game_name:'Jogo',  
  bonus_active:'Active',
  bonus_collected: 'Bônus Coletado',
  bonus_cancelled: 'Bônus Cancelado',
  loading_game_history:'Carregando Histórico do Jogo',  
  bonus_by_status:'Bônus Status',  
  total_cashback:'Total Cashback',  
  total_jackpot:'Total do Jackpot',  
  total_bonus:'Total Bônus',  
  cashback_history:'Histórico de Cashback',  
  bonus_amount:'Valor do Bônus',  
  bonus_cashback: "Bônus (Cashback)",
    bonus_pending: "Pendente",
    bonus_jackpot: "Bônus(Jackpot)",



},

"errors": {
    "need_balance_to_launch": "Você precisa de saldo para jogar"
  },
  "common": {
    "close": "FECHAR"
  }

}